import { AxiosRequestConfig } from "axios";

export const postRegisterConfig: AxiosRequestConfig = {
  method: "post",
  url: "/user",
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
};
